var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3947 9.52981L14.9499 10.3077L13.3947 11.0879L12.6174 12.6401L11.8401 11.0879L10.285 10.3077L11.8401 9.52981L12.6174 7.97522L13.3947 9.52981ZM4.84277 4.10975L3.2876 3.33246L4.84277 2.55517L5.62006 1L6.39735 2.55517L7.95252 3.33246L6.39735 4.10975L5.62006 5.66492L4.84277 4.10975ZM12.2285 3.7214L10.8681 3.0409L12.2285 2.36041L12.909 1L13.5895 2.36041L14.9499 3.0409L13.5895 3.7214L12.909 5.08181L12.2285 3.7214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00017 13.1936C0.992127 12.7306 1.16413 12.2826 1.47994 11.944L6.27099 7.15221L8.81833 9.65705L4.00482 14.4695C3.66612 14.7852 3.21808 14.9571 2.75511 14.9489C2.29215 14.9408 1.85043 14.7532 1.52306 14.4258C1.19568 14.0983 1.00821 13.6566 1.00017 13.1936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78451 4.87532L11.0741 6.16487C11.4157 6.50648 11.4156 7.06034 11.074 7.40191L9.48732 8.98821L6.94206 6.48104L8.54749 4.87537C8.88906 4.53374 9.44291 4.53372 9.78451 4.87532Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.ac642ce2fa49d961ccebb7fe8352608b.svg";
export { ForwardRef as ReactComponent };